angular.module('impactx.basket').directive('ixCodeInput', CodeInput);

CodeInput.$inject = ['TranslationService', '$timeout'];

function CodeInput(TranslationService, $timeout) {
    return {
        scope: {
            model: "=",
            name: '@?',
            required: "=?",
            requiredLabel: '@?',
            validationLabel: '@?'
        },
        restrict: 'E',
        templateUrl: 'modules/basket/templates/codeinput.tmpl.html',
        link: function(scope, element) {
            var KEY_BACKSPACE = 8;
            var KEY_DELETE = 46;
            var KEY_LEFT = 37;
            var KEY_RIGHT = 39;
            var KEY_SPACE = 32;
            var LENGTH = 6;
            var REG_EXP = new RegExp(/[^A-Z0-9]/g);

            scope.inputs = [];
            
            scope.requiredLabel = scope.requiredLabel ? scope.requiredLabel : TranslationService.get("required");
            scope.name = scope.name ? scope.name : 'code_input';
            scope.required = scope.required ? scope.required : false;

            scope.model = scope.model ? scope.model : "";
            scope.viewValue = [];
            for (var j = 0; j < LENGTH; j++) {
                scope.viewValue.push({value: ""});
            }
            // need some time before we can collect the inputs
            $timeout(function() {
                for (var id=0; id < LENGTH; id++) {
                    var input = element[0].querySelector("input#" + scope.name + '_' + id);
                    if (input) {
                        scope.inputs.push(input);
                    }
                }
            }, 100);
            
            var focusInput = function(index, cursor) {
                $timeout(function () {
                    // console.log("focusInput(index: " + index + "; cursor: " + cursor + ")");
                    if (index >= LENGTH) {
                        index = LENGTH - 1;
                    }
                    var input = scope.inputs[index];
                    if (input) {
                        input.focus();
                        input.selectionStart = cursor;
                        input.selectionEnd = cursor;
                    }
                });
            };
            
            var format = function() {
                for (var k = 0; k < scope.model.length; k++) {
                    scope.viewValue[k].value = scope.model.substring(k, k + 1);
                }
                for (k; k < LENGTH; k++) {
                    scope.viewValue[k].value = "";
                }
            };
            
            var getCursor = function(inputIndex) {
                return scope.inputs[inputIndex].selectionStart;
            };

            /**
             * Handles some special key presses (namely "Backspace", "Delete", "ArrowLeft", "ArrowRight" and "Space").
             * While the arrow-keys only have navigational function, "Backspace" needs to be handled separately if pressed in an empty input,
             * because it needs to clear the input left from the current.
             * 
             * @param event the event holding the key information.
             * @param inputIndex the index of the input the event was fired from.
             */
            scope.handleKey = function(event, inputIndex) {
                // console.log("handleKey(key: "+event.key+"; keyCode: "+event.keyCode+")");
                if(event && event.keyCode) {
                    var cursor = getCursor(inputIndex); // since this is before the change event, cursor should only have value 0 or 1
                    var notCursor = cursor === 0 ? 1 : 0;
                    var result;
                    var currentHasValue = !!scope.viewValue[inputIndex].value;
                    if (event.keyCode === KEY_BACKSPACE) {
                        // backspace if cursor is at 0 => clear input left from current and update
                        // no need to do anything if we already are at the leftmost input
                        if (inputIndex+cursor > 0) {
                            result = scope.model.substring(0, inputIndex+cursor-1)+
                                scope.model.substring(inputIndex+cursor);
                            scope.model = result.replace(REG_EXP, "");
                            
                            // scope.viewValue[inputIndex + cursor - 1].value = "";
                            format();
                            focusInput(inputIndex + cursor - 1, currentHasValue ? 0 : 1);
                            event.preventDefault(); // prevent change event
                        }
                    }
                    else if (event.keyCode === KEY_DELETE) {
                        // delete if cursor is at 1 => clear input right from current and update
                        // no need to do anything if we already are at the rightmost input
                        if (inputIndex + cursor < LENGTH) {
                            result = scope.model.substring(0, inputIndex)+
                                scope.model.substring(inputIndex+1);
                            scope.model = result.replace(REG_EXP, "");

                            // scope.viewValue[inputIndex + cursor].value = "";
                            format();
                            focusInput(inputIndex, cursor);
                            event.preventDefault(); // prevent change event
                        }
                    }
                    else if (event.keyCode === KEY_LEFT) {
                        // navigate to the left
                        if(inputIndex > 0) {
                            focusInput(inputIndex + cursor - 1, notCursor);
                            event.preventDefault();
                        }
                    }
                    else if (event.keyCode === KEY_RIGHT) {
                        // navigate to the right
                        if (inputIndex < LENGTH) {
                            focusInput(inputIndex + (currentHasValue ? cursor : 1), notCursor);
                            event.preventDefault();
                        }
                    }
                    else if(event.keyCode === KEY_SPACE) {
                        event.preventDefault(); // do nothing on spacebar
                    }
                }
            };

            scope.update = function(inputIndex) {
                var cursor = getCursor(inputIndex) - 1; // cursor should only have value 0 or 1
                var index = inputIndex + cursor;
                var notCursor = cursor === 0 ? 1 : 0;
                
                if (inputIndex < LENGTH) {
                    var modelBefore = scope.model;
                    var result = scope.model.substring(0, inputIndex) +
                        scope.viewValue[inputIndex].value.trim() +
                        scope.model.substring(inputIndex+1);
                    scope.model = result.toUpperCase()
                        .replace(REG_EXP, "")
                        .substring(0, LENGTH);
                    format();
                    
                    var newCursor = cursor;
                    if (index === LENGTH - 1) {
                        newCursor = 1;
                    }
                    var length = scope.model.length;
                    var offset = modelBefore.length <= length ? notCursor : 0;
                    if(index > length) {
                        index = length;
                        offset = 0;
                    }
                    if (modelBefore !== scope.model) {
                        focusInput(index + offset, newCursor);
                    }
                    else { // set the focus where it was if the model did not change
                        focusInput(inputIndex, cursor);
                    }
                }
            };

            // initial update
            format();
        }
    };
}